import { ConfigProvider } from 'antd';
import ruRu from 'antd/locale/ru_RU';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import AuthContextProvider from '../Auth/AuthContextProvider';
import ConfigContextProvider from '../Config/ConfigContextProvider';
import CsrfFetcher from '../CsrfFetcher/CsrfFetcher';
import Layout from '../Layout/Layout';
import LoadingContextProvider from '../Loading/LoadingContextProvider';
import RequireAuth from '../RequireAuth/RequireAuth';
import Router from '../Router/Router';

import 'styles/main.less';

const Entry = () => {
	return (
		<ConfigProvider locale={ruRu}>
			<ConfigContextProvider>
				<LoadingContextProvider>
					<CsrfFetcher>
						<AuthContextProvider>
							<BrowserRouter>
								<RequireAuth>
									<Layout>
										<Router />
									</Layout>
								</RequireAuth>
							</BrowserRouter>
						</AuthContextProvider>
					</CsrfFetcher>
				</LoadingContextProvider>
			</ConfigContextProvider>
		</ConfigProvider>
	);
};

export default Entry;
